"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(str) {
  return str.trim().replace(' ', '_').replace(/[^a-zA-Z0-9_-]/g, '-_-');
};

exports["default"] = _default;